import { useSelector } from 'react-redux';
import { selectIsEmvPayment } from '../selectors';
import { useCheckoutMapper } from './use-checkout-mapper';
import { useEmvPaymentDevice } from './use-emv-payment-device';
import { usePurchaseMutation } from './use-purchase-mutation';
import type { EmvTransaction } from '@ticketmaster/tm1pos-web-shared/payment/emvPaymentModule-types';

export const usePurchaseMonitor = () => {
  const isEmvPayment = useSelector(selectIsEmvPayment);

  const { mapToPurchaseRequest } = useCheckoutMapper();
  const { purchase } = usePurchaseMutation();
  const paymentDevice = useEmvPaymentDevice();

  const trigger = () => {
    (async () => {
      try {
        let emvPayment: EmvTransaction | undefined;

        if (isEmvPayment) {
          const result = await paymentDevice.waitForEmvTransactionCompletion();

          if (result.status === 'SUCCESS') {
            emvPayment = result.emvTransaction;
          } else {
            // error was handled inside emvPaymentModule
            return;
          }
        }

        const request = mapToPurchaseRequest(emvPayment);
        await purchase(request);
      } catch (e) {
        console.error(e);
      }
    })().then();
  };

  return { fireAndForget: trigger };
};
